import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function PaginatedItems({
	totalCount,
	countPerPage,
	pageNumber,
	onValueChanged,
}) {
	const onPageChanged = (event) => {
		onValueChanged("pageNumber", event.selected + 1);
	};

	return (
		<div className="pagination">
			<ReactPaginate
				breakLabel="..."
				nextLabel={<FaArrowRight />}
				onPageChange={onPageChanged}
				pageRangeDisplayed={5}
				forcePage={pageNumber - 1}
				pageCount={
					Number.isNaN(totalCount / countPerPage)
						? 0
						: Math.ceil(totalCount / countPerPage)
				}
				previousLabel={<FaArrowLeft />}
				renderOnZeroPageCount={null}
				activeClassName="active-pagination"
				containerClassName="react-paginate"
				pageLinkClassName="page-link"
				previousLinkClassName="page-link"
				nextLinkClassName="page-link"
				disabledClassName="disabled"
			/>
		</div>
	);
}

export default PaginatedItems;
